import React from 'react'

import ContactFormMobile from './contactForm.container'
import ContactLocationMobile from './contactLocation.components'

import pill from "./../../../UI/general/pill.svg"

interface Props{
  isContactModalOpened: boolean,
  logoProyecto: any,
  data: any,
  colorsData: any,
  handleOpenContactModal: any
}

interface State{
  isFormOpened: boolean,
  isLocationOpened: boolean
}

class ContactContainerMobile extends React.Component<Props,State>{
  constructor(props: Props){
    super(props)
    this.state = {
      isFormOpened: true,
      isLocationOpened: false
    }
  }

  render(): React.ReactNode {
      return(
        <div className={this.props.isContactModalOpened ? "contact-modal-mobile-opened":"contact-modal-mobile-collapsed"}>
          
          <div className='close-quotation-modal-mobile' onClick = {() => {this.props.handleOpenContactModal()}}>
            <img src={pill} alt=""/> 
          </div>

          <div className='contact-modal-btns-selection-container'>
            <div 
              className={"contact-modal-btn"}
              style={{
                backgroundColor: this.state.isFormOpened && this.props.colorsData ? this.props.colorsData.main_buttons:"#fff",
                color: this.state.isFormOpened && this.props.colorsData ? this.props.colorsData.secondary_text:this.props.colorsData.main_text,
                border: "0.1vh solid" + this.state.isFormOpened && this.props.colorsData ? this.props.colorsData.main_buttons+ " 0.1vh solid":this.props.colorsData.main_text+ " 0.1vh solid"
              }}
              onClick={() => {
                this.setState({
                  isFormOpened: true,
                  isLocationOpened: false
                })
              }}
            >
              Formulario
            </div>
            <div 
              className={"contact-modal-btn"}
              style={{
                backgroundColor: this.state.isLocationOpened && this.props.colorsData ? this.props.colorsData.main_buttons:"#fff",
                color: this.state.isLocationOpened && this.props.colorsData ? this.props.colorsData.secondary_text:this.props.colorsData.main_text,
                border: this.state.isLocationOpened && this.props.colorsData ? this.props.colorsData.main_buttons + " 0.1vh solid" :this.props.colorsData.main_text+ " 0.1vh solid"
              }}
              onClick={() => {
                this.setState({
                  isFormOpened: false,
                  isLocationOpened: true
                })
              }}
            >
              Ubicación
            </div>
          </div>
        
          <ContactFormMobile
            isFormOpened = {this.state.isFormOpened}
            logoConstructora={this.props.logoProyecto}
            colorsData={this.props.colorsData}
            isContactModalOpened = {this.props.isContactModalOpened}
          />

          <ContactLocationMobile
            isLocationOpened={this.state.isLocationOpened}
            logoConstructora={this.props.logoProyecto}
            colorsData={this.props.colorsData}
            contactData={this.props.data}
            isContactModalOpened = {this.props.isContactModalOpened}
          />
        </div>
      )
  }
}

export default ContactContainerMobile